import type { InputControlProps } from '@/components/input-control/input-control.types';
import clsx from 'clsx';
import '@/components/input-control/input-control.css';

export default function InputControl(props: InputControlProps) {
  return (
    <div
      className={clsx(
        props.className,
        'input-control',
        'input-control--'.concat(props.size || 'lg'),
        'input-control--'.concat(props.shape || 'radio'),
        {
          'input-control--checked': props.checked,
          'input-control--hovered': props.hovered,
          'input-control--error': props.error,
          'input-control--focused': props.focused,
          'input-control--disabled': props.disabled,
        },
      )}
    />
  );
}
